//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            roleName: null,
            unitTypesLoading: false,
            unitTypes: [],
            updateUnitType: false
        };
    },


    methods: {
        close: function close() {
            Event.$emit('close-full-modal');
        },
        load: function load() {
            var _this = this;

            this.$children[0].$data.showModal = true;
            axios.get('/api/unitTypes').then(function (response) {
                _this.unitTypes = response.data.unitTypes;
                _this.roleName = response.data.roleName;
                _this.unitTypesLoading = false;
            });
        },
        addUnitType: function addUnitType() {
            this.unitTypes.unshift({
                name: '',
                description: '',
                square_feet: null,
                bedrooms: '',
                bathrooms: '',
                market_rent_unit_type: '',
                pro_forma_amount: ''
            });

            this.updateUnitType = 0;
        },
        removeUnitType: function removeUnitType(unitType, idx) {
            if (unitType.id) {
                Event.$emit('confirm-delete', unitType, '/api/unitTypes/' + unitType.id, 'delete-entry', 'Are you sure you want to delete this unit type?', 'Delete', '', true);
            } else {
                this.updateUnitType = false;
                this.unitTypes.splice(idx, 1);
            }
        },


        saveUnitType: function saveUnitType(type, idx) {
            var _this2 = this;

            this.updateUnitType = false;
            this.unitTypesLoading = true;

            axios.post('/prototype/properties/' + this.$store.state.selectedProperty + '/unitTypes', { type: type }).then(function (response) {
                _this2.unitTypes[idx] = response.data;
                _this2.unitTypesLoading = false;
            });
        }

    },

    created: function created() {
        Event.$on('property-settings-unit-types', this.load);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('property-settings-unit-types');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/settings/PropertySettingsUnitTypes.vue
// module id = eNI6
// module chunks = 0 1